<template>
  <div>
    <banner></banner>
    <div class="h1_p" :class="{mlr: !pc}">
      <h1 :class="{f36: !pc}">{{ $t('projects.h1') }}</h1>
      <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="pc?$t('projects.p'):$t('projects.p').replace(/&lt;br>/, '')"></p>
    </div>
    <projects></projects>
    <div class="h1_p" :class="{mlr: !pc}">
      <h1 :class="{f36: !pc}">{{ $t('viewpoints.h1') }}</h1>
      <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="pc?$t('viewpoints.p'):$t('viewpoints.p').replace(/&lt;br>/, '')"></p>
    </div>
    <viewpoints></viewpoints>
    <intelligence></intelligence>
    <div class="h1_p" :class="{mlr: !pc}">
      <h1 :class="{f36: !pc}">{{ $t('company.professionals.h1') }}</h1>
      <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="pc?$t('company.professionals.p'):$t('company.professionals.p').replace(/&lt;br>/, '')"></p>
    </div>
    <people></people>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import banner from '@/components/home/banner'
import projects from '@/components/home/projects'
import viewpoints from '@/components/home/viewpoints'
import intelligence from '@/components/home/intelligence'
import people from '@/components/home/people'
export default {
  name: 'Home',
  components: {
    banner,
    projects,
    viewpoints,
    intelligence,
    people
  },
  computed: {
    ...mapGetters(['pc'])
  }
}
</script>
